var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.5,407.56a18.39,18.39,0,0,1,11.39-1.39c2.07.35,4.23,1,5.64,2.52s1.67,4.29.05,5.62a5.38,5.38,0,0,1-3.55.9c-3,0-6.35-.56-8.76,1.25-1.37,1-2.29,2.75-3.93,3.26a3.87,3.87,0,0,1-4.27-1.9,6.64,6.64,0,0,1-.48-4.9A7.44,7.44,0,0,1,425.5,407.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.55,392.23c2.12,3,6.24,2,8.15.17s2.72-4.52,3.46-7.08c1.68-5.83,3.37-12,2.12-17.9a9.92,9.92,0,0,0-2.29-4.87,5.19,5.19,0,0,0-4.92-1.64c-2.08.55-3.37,2.59-4.3,4.52a42.72,42.72,0,0,0-4.22,18.32c0,2.95.34,6,2,8.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.73,396.57a11,11,0,0,0,1.72-10.14,19.6,19.6,0,0,0-6-8.71,32.14,32.14,0,0,0-10.75-6.34,11.56,11.56,0,0,0-4.84-.83,5.1,5.1,0,0,0-4.06,2.46c-1.13,2.16,0,4.78,1.13,6.91A83.06,83.06,0,0,0,396,390.68c2.12,2.73,4.54,5.42,7.77,6.65s6.58,1.09,8.29-1.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.41,437.9a6.93,6.93,0,0,0,.19-1.37c.1-1,.22-2.26.37-3.76a52.6,52.6,0,0,1,.84-5.51,43,43,0,0,1,2-6.5,23.85,23.85,0,0,1,3.32-5.88,12.4,12.4,0,0,1,4.2-3.49,11.94,11.94,0,0,1,3.53-1.1,6.39,6.39,0,0,0,1.37-.2,6.78,6.78,0,0,0-1.39,0,10.83,10.83,0,0,0-3.69,1,12.43,12.43,0,0,0-4.42,3.52,23.09,23.09,0,0,0-3.44,6,39.26,39.26,0,0,0-2,6.61,44.82,44.82,0,0,0-.73,5.57c-.12,1.6-.17,2.89-.19,3.78A6.23,6.23,0,0,0,417.41,437.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.67,435a2.63,2.63,0,0,0,0-.64v-1.82c0-1.59,0-3.88.08-6.71.14-5.66.63-11.76,1.57-20.35.89-8.08,2.09-17.48,3.35-23.59.27-1.39.55-2.64.8-3.74s.46-2,.66-2.81.31-1.31.43-1.78a2.62,2.62,0,0,0,.11-.62,2.2,2.2,0,0,0-.22.59c-.14.46-.32,1-.53,1.75s-.48,1.7-.76,2.8-.58,2.34-.88,3.72a206.93,206.93,0,0,0-3.52,21.9c-1,8.61-1.37,16.45-1.41,22.12,0,2.84,0,5.14.1,6.72,0,.75.08,1.35.11,1.83A2.38,2.38,0,0,0,417.67,435Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.71,419.89a12,12,0,0,0,0-1.9c-.07-1.23-.24-3-.58-5.17a69.43,69.43,0,0,0-1.68-7.53,62.07,62.07,0,0,0-3.15-8.91A47.48,47.48,0,0,0,403,382a22.77,22.77,0,0,0-2.18-2c-.33-.29-.63-.57-.93-.79l-.84-.58a12.27,12.27,0,0,0-1.61-1,55.4,55.4,0,0,1,5.26,4.7,49.89,49.89,0,0,1,9,14.34,70.29,70.29,0,0,1,3.16,8.82,74.08,74.08,0,0,1,1.79,7.46c.4,2.15.62,3.9.76,5.11A12.54,12.54,0,0,0,417.71,419.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.59,122.86l-54.28,16.33a5,5,0,0,1-6.21-3.34l-22-73.14a5,5,0,0,1,3.34-6.21l38-11.41,27.27,14.19,17.26,57.37A5,5,0,0,1,444.59,122.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.34,44.91l4.38,14.54A6.79,6.79,0,0,0,416.18,64l14.49-4.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.1,110.87a1.56,1.56,0,0,0-.06-.18l-.17-.49q-.21-.69-.6-1.92c-.52-1.7-1.28-4.14-2.24-7.24-1.9-6.23-4.61-15.1-7.86-25.73l.28.15-37,11.17c0,.07.33-.61.18-.32h0v.06l0,.08.05.15.09.3.18.61.37,1.21.72,2.42,1.43,4.75,2.76,9.2c1.79,6,3.48,11.64,5,16.84l-.28-.15,26.79-7.94,7.58-2.22,2-.58.52-.14a.67.67,0,0,1,.19,0l-.15.06-.5.16-1.95.61L422,114l-26.87,8.2-.22.07-.07-.22c-1.57-5.2-3.27-10.84-5.08-16.82q-1.35-4.48-2.78-9.2l-1.43-4.75-.72-2.42-.37-1.21-.18-.61-.09-.3-.05-.15,0-.08v-.06h0c-.16.29.21-.4.17-.33l37-11.1.22-.07.06.22c3.18,10.72,5.82,19.65,7.68,25.93.91,3.09,1.62,5.53,2.12,7.23l.54,1.89.13.48C432.1,110.82,432.11,110.87,432.1,110.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.36,117c-.14,0-2.65-7.9-5.6-17.73s-5.25-17.85-5.11-17.89,2.64,7.9,5.6,17.74S413.5,116.92,413.36,117Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.34,102.18c0,.13-8.25,2.75-18.51,5.84s-18.63,5.48-18.67,5.34,8.25-2.75,18.52-5.84S429.29,102,429.34,102.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,93c0,.14-8.25,2.75-18.51,5.84s-18.62,5.48-18.67,5.34,8.25-2.75,18.52-5.84S427,92.83,427,93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,84c0,.14-8.18,2.73-18.37,5.8s-18.48,5.44-18.52,5.3,8.18-2.74,18.37-5.8S424,83.83,424,84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,198.11l-28-5a2.5,2.5,0,0,1-2-2.9l6.75-37.67a2.49,2.49,0,0,1,2.9-2L47.22,154l9,12.53-5.3,29.55A2.5,2.5,0,0,1,48,198.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.23,153.92l-1.34,7.49a3.4,3.4,0,0,0,2.75,4l7.55,1.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.13,189.91a2.23,2.23,0,0,1,0-.36l.15-1c.15-.92.36-2.18.62-3.76.55-3.25,1.33-7.8,2.26-13.25l.18.26L29.3,168.4l.3-.2h0v.06l0,.08,0,.16-.06.31-.11.62c-.08.42-.15.83-.22,1.24-.15.83-.3,1.65-.45,2.45-.29,1.62-.57,3.2-.85,4.74-.56,3.08-1.09,6-1.58,8.66l-.18-.26,13.73,2.58,3.89.76,1,.21.37.09-.33,0-1-.15-3.86-.64L26,186.72l-.23,0,0-.23c.48-2.68,1-5.59,1.53-8.67.28-1.54.56-3.12.85-4.74.14-.81.29-1.62.43-2.45.08-.41.15-.82.23-1.24l.11-.62.05-.32,0-.15,0-.08v-.06h0l.3-.21,19.07,3.46.22,0,0,.22c-1,5.49-1.9,10.08-2.51,13.35-.3,1.55-.55,2.79-.72,3.69-.08.39-.15.7-.2,1A1.27,1.27,0,0,1,45.13,189.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.37,188.39a83.81,83.81,0,0,1,1.39-9.22,85,85,0,0,1,1.9-9.13,83.81,83.81,0,0,1-1.39,9.22A82.13,82.13,0,0,1,35.37,188.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.86,185.4a88.16,88.16,0,0,1-9.62-1.46,89.32,89.32,0,0,1-9.52-2,91.2,91.2,0,0,1,9.62,1.46A92.39,92.39,0,0,1,45.86,185.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.92,180.77a94,94,0,0,1-9.62-1.46,91.28,91.28,0,0,1-9.53-2,90.4,90.4,0,0,1,9.62,1.46A88.29,88.29,0,0,1,46.92,180.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.61,176.06a89.12,89.12,0,0,1-9.54-1.44,93.53,93.53,0,0,1-9.46-2,86.14,86.14,0,0,1,9.55,1.44A89.77,89.77,0,0,1,47.61,176.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.63,437.77c0,.14-98.34.26-219.62.26s-219.64-.12-219.64-.26,98.32-.26,219.64-.26S469.63,437.63,469.63,437.77Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.79,106.67,111,120.07a3.61,3.61,0,0,1-4.59-2.23l-18-52.26A3.61,3.61,0,0,1,90.6,61l27.12-9.36,20.15,9.46,14.16,41A3.6,3.6,0,0,1,149.79,106.67Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.68,51.5l3.59,10.38a4.92,4.92,0,0,0,6.25,3.05l10.35-3.84Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.68,51.5l3.59,10.38a4.92,4.92,0,0,0,6.25,3.05l10.35-3.84Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M140.41,98.36a4,4,0,0,1-.2-.48c-.12-.34-.29-.8-.5-1.37l-1.84-5.17c-1.58-4.47-3.8-10.78-6.47-18.36l.29.14-26.44,9.17c0,.08.3-.62.16-.32h0v0l0,0,0,.11.07.22.15.43.3.87.6,1.72c.39,1.15.78,2.28,1.17,3.4.77,2.24,1.53,4.44,2.26,6.58,1.47,4.27,2.86,8.31,4.13,12l-.28-.14L133,100.8,138.44,99l1.45-.48.52-.15a3,3,0,0,1-.46.19l-1.39.5L133.23,101,114,107.71l-.21.08-.07-.22c-1.29-3.71-2.7-7.74-4.18-12L107.28,89c-.39-1.12-.78-2.26-1.17-3.4l-.6-1.72-.3-.87-.15-.43-.07-.22,0-.11,0,0v0h0c-.14.29.2-.41.17-.34l26.46-9.1.22-.07.07.21c2.59,7.66,4.76,14,6.29,18.56l1.72,5.16c.18.57.33,1,.44,1.35S140.42,98.37,140.41,98.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,103.32c-.13.05-2.21-5.61-4.64-12.64s-4.29-12.76-4.15-12.81,2.21,5.61,4.64,12.64S127.17,103.27,127,103.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.15,92.16c0,.13-5.86,2.3-13.19,4.83s-13.32,4.48-13.37,4.34,5.86-2.3,13.2-4.83S138.11,92,138.15,92.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.21,85.57c0,.13-5.86,2.3-13.19,4.83s-13.32,4.48-13.37,4.34,5.86-2.3,13.2-4.83S136.17,85.43,136.21,85.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.77,79.15c0,.13-5.82,2.28-13.09,4.79s-13.22,4.45-13.27,4.31,5.82-2.28,13.1-4.8S133.72,79,133.77,79.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.93,340.16,404.6,350.87a2,2,0,0,1-2.73-.85l-14.43-27.39a2,2,0,0,1,.84-2.73l14.22-7.49,12,3.53,11.32,21.49A2,2,0,0,1,424.93,340.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.47,312.34l2.87,5.44a2.75,2.75,0,0,0,3.72,1.16l5.4-3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,336.35a9.45,9.45,0,0,1-.57-1l-1.49-2.7-5.17-9.57.31.1-13.86,7.34.11-.35h0l0,0,0,.06.06.11.12.23.24.45.47.91.94,1.78,1.81,3.45,3.3,6.31-.31-.09,10-5.16,2.88-1.44c.67-.34,1-.51,1.06-.51a7.56,7.56,0,0,1-.93.55l-2.77,1.53-10.07,5.43-.19.11-.11-.2c-1-1.95-2.16-4.06-3.34-6.3-.6-1.12-1.2-2.27-1.83-3.44l-.94-1.78-.47-.9-.24-.46-.12-.22-.06-.12,0-.06,0,0v0h0c-.1.31.13-.43.11-.35l13.89-7.28.2-.1.1.2c2.06,4,3.78,7.37,5,9.79.56,1.13,1,2,1.36,2.71A8.33,8.33,0,0,1,419,336.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.05,340.23a53,53,0,0,1-3.75-6.55,53.62,53.62,0,0,1-3.28-6.79,56.43,56.43,0,0,1,3.74,6.55A58.09,58.09,0,0,1,412.05,340.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.25,333.11a58.9,58.9,0,0,1-6.84,3.9,61.91,61.91,0,0,1-7.08,3.44,58.23,58.23,0,0,1,6.84-3.9A59.76,59.76,0,0,1,417.25,333.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.62,329.63a60.89,60.89,0,0,1-6.84,3.89A59.76,59.76,0,0,1,401.7,337a117.39,117.39,0,0,1,13.92-7.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.72,326.28a115.62,115.62,0,0,1-13.82,7.28,117.7,117.7,0,0,1,13.82-7.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Spreadsheets--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.25,
    y: 114.31,
    width: 387.11,
    height: 209.9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.25,
    y: 114.31,
    width: 387.11,
    height: 17.68,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.41,
    cy: 123.39,
    r: 2.19,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.38,
    cy: 123.39,
    r: 2.19,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.35,
    cy: 123.39,
    r: 2.19,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.67,
    y: 162.37,
    width: 14.08,
    height: 161.83,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.39,
    y: -30.58,
    width: 14.08,
    height: 387.52,
    transform: "translate(104.25 430.61) rotate(-90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.75,315.19c-.14,0-.26-35.6-.26-79.52s.12-79.53.26-79.53.26,35.6.26,79.53S87.9,315.19,87.75,315.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.11,324.2c-.14,0-.26-37.62-.26-84s.12-84,.26-84,.26,37.62.26,84S143.25,324.2,143.11,324.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,324.2c-.14,0-.26-37.5-.26-83.75s.12-83.75.26-83.75.26,37.49.26,83.75S202,324.2,201.83,324.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.17,324.2c-.15,0-.26-37.5-.26-83.75s.11-83.75.26-83.75.26,37.49.26,83.75S259.31,324.2,259.17,324.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.85,324.2c-.14,0-.26-37.62-.26-84s.12-84,.26-84,.26,37.62.26,84S318,324.2,317.85,324.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.54,324.2c-.15,0-.26-37.62-.26-84s.11-84,.26-84,.26,37.62.26,84S376.68,324.2,376.54,324.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.22,324.2c-.14,0-.26-37.5-.26-83.75s.12-83.75.26-83.75.26,37.49.26,83.75S435.37,324.2,435.22,324.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,183.07c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.27,192.7-.27S459.05,182.92,459.05,183.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,170.22c0,.15-86.27.26-192.67.26s-192.7-.11-192.7-.26,86.26-.26,192.7-.26S459.05,170.08,459.05,170.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,196.59c0,.15-86.27.26-192.67.26s-192.7-.11-192.7-.26,86.26-.26,192.7-.26S459.05,196.45,459.05,196.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,210.12c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.26,192.7-.26S459.05,210,459.05,210.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,223.65c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.26,192.7-.26S459.05,223.5,459.05,223.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,237.17c0,.15-86.27.26-192.67.26s-192.7-.11-192.7-.26,86.26-.26,192.7-.26S459.05,237,459.05,237.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,250.7c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.26,192.7-.26S459.05,250.56,459.05,250.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,264.23c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.26,192.7-.26S459.05,264.08,459.05,264.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,277.75c0,.15-86.27.27-192.67.27s-192.7-.12-192.7-.27,86.26-.26,192.7-.26S459.05,277.61,459.05,277.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,291.28c0,.15-86.27.26-192.67.26s-192.7-.11-192.7-.26,86.26-.26,192.7-.26S459.05,291.14,459.05,291.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,304.81c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.26,192.7-.26S459.05,304.67,459.05,304.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.05,318.34c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.26,192.7-.26S459.05,318.19,459.05,318.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.75,
    y: 170.22,
    width: 373.43,
    height: 26.37,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.74,181.57c0,.14-43.94.26-98.14.26s-98.14-.12-98.14-.26,43.93-.26,98.14-.26S381.74,181.42,381.74,181.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.33,189.08c0,.14-54.95.26-122.72.26s-122.74-.12-122.74-.26,54.94-.26,122.74-.26S400.33,188.93,400.33,189.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.11,
    y: 210.12,
    width: 116.06,
    height: 13.53,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.11,
    y: 222.15,
    width: 116.06,
    height: 57.09,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.21,229.81c0,.15-9.58.26-21.39.26s-21.39-.11-21.39-.26,9.58-.26,21.39-.26S192.21,229.67,192.21,229.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.13,244.66c0,.15-5.76.26-12.85.26s-12.85-.11-12.85-.26,5.75-.26,12.85-.26S175.13,244.52,175.13,244.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.34,255.48c0,.14-10.5.26-23.45.26s-23.46-.12-23.46-.26,10.5-.26,23.46-.26S196.34,255.33,196.34,255.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.13,233.85c0,.14-5.76.26-12.85.26s-12.85-.12-12.85-.26,5.75-.26,12.85-.26S175.13,233.7,175.13,233.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.86,229.81a43.94,43.94,0,0,1-6.82.26,43.94,43.94,0,0,1-6.82-.26,45.48,45.48,0,0,1,6.82-.26A45.48,45.48,0,0,1,254.86,229.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.86,242a45.48,45.48,0,0,1-6.82.26,45.48,45.48,0,0,1-6.82-.26,43.94,43.94,0,0,1,6.82-.26A43.94,43.94,0,0,1,254.86,242Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.86,255.48a45.48,45.48,0,0,1-6.82.26,45.48,45.48,0,0,1-6.82-.26,43.94,43.94,0,0,1,6.82-.26A43.94,43.94,0,0,1,254.86,255.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.11,272c0,.14-4.83.26-10.79.26s-10.78-.12-10.78-.26,4.82-.26,10.78-.26S254.11,271.86,254.11,272Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,278.25c-.14,0-.26-12.34-.26-27.55s.12-27.55.26-27.55.26,12.33.26,27.55S202,278.25,201.83,278.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.2,263c0,.14-12.83.26-28.66.26s-28.65-.12-28.65-.26,12.82-.26,28.65-.26S258.2,262.88,258.2,263Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.11,
    y: 304.31,
    width: 116.06,
    height: 14.03,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.92,
    y: 291.28,
    width: 116.25,
    height: 13.53,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,312c0,.15-10.95.26-24.45.26s-24.45-.11-24.45-.26,10.94-.26,24.45-.26S197.32,311.87,197.32,312Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.11,311.32c0,.14-4.83.26-10.79.26s-10.78-.12-10.78-.26,4.82-.26,10.78-.26S254.11,311.18,254.11,311.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.68,
    y: 256.98,
    width: 10.04,
    height: 34.06,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.68,
    y: 263.16,
    width: 10.04,
    height: 27.88,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.35,
    y: 270.95,
    width: 10.04,
    height: 20.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.02,
    y: 236.09,
    width: 10.04,
    height: 54.95,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.35,
    y: 236.09,
    width: 10.04,
    height: 54.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.01,
    y: 223.4,
    width: 10.04,
    height: 67.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.67,
    y: 138.17,
    width: 8.91,
    height: 8.91,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.76,151h-9.9v-9.91h9.9Zm-8.9-1h7.9v-7.91h-7.9Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.81,
    y: 140.53,
    width: 8.32,
    height: 8.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.33,
    y: 140.53,
    width: 8.32,
    height: 8.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.85,
    y: 140.53,
    width: 8.32,
    height: 8.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.38,
    y: 140.53,
    width: 8.32,
    height: 8.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.9,
    y: 140.53,
    width: 8.32,
    height: 8.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.6,
    y: 140.45,
    width: 87.94,
    height: 8.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.61,
    y: 140.45,
    width: 87.94,
    height: 8.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.37,
    y: 140.45,
    width: 75.82,
    height: 8.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.36,324.2c0-1.58-.08-80.78-.2-209.89l.2.19-387.08.07h0l.26-.26c0,74.16,0,145.16,0,209.89l-.24-.24,387.11.24-387.11.25H74v-.25c0-64.73,0-135.73,0-209.89v-.26h.29l387.08.06h.2v.2C461.43,243.42,461.36,322.63,461.36,324.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.46,
    y: 97.35,
    width: 387.11,
    height: 209.9,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.46,
    y: 97.35,
    width: 387.11,
    height: 17.68,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.63,
    cy: 106.43,
    r: 2.19,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.6,
    cy: 106.43,
    r: 2.19,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.57,
    cy: 106.43,
    r: 2.19,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.89,
    y: 145.41,
    width: 14.08,
    height: 161.83,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.61,
    y: -47.54,
    width: 14.08,
    height: 387.52,
    transform: "translate(95.42 387.87) rotate(-90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,298.23c-.14,0-.26-35.61-.26-79.52s.12-79.53.26-79.53.26,35.6.26,79.53S62.11,298.23,62,298.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.33,307.24c-.14,0-.26-37.62-.26-84s.12-84,.26-84,.26,37.62.26,84S117.47,307.24,117.33,307.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.05,307.24c-.14,0-.26-37.5-.26-83.75s.12-83.75.26-83.75.26,37.49.26,83.75S176.2,307.24,176.05,307.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.39,307.24c-.15,0-.26-37.5-.26-83.75s.11-83.75.26-83.75.26,37.49.26,83.75S233.53,307.24,233.39,307.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.07,307.24c-.14,0-.26-37.62-.26-84s.12-84,.26-84,.26,37.62.26,84S292.21,307.24,292.07,307.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.76,307.24c-.15,0-.27-37.62-.27-84s.12-84,.27-84,.26,37.62.26,84S350.9,307.24,350.76,307.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.44,307.24c-.14,0-.26-37.5-.26-83.75s.12-83.75.26-83.75.26,37.49.26,83.75S409.58,307.24,409.44,307.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,166.1c0,.15-86.27.27-192.67.27s-192.7-.12-192.7-.27,86.26-.26,192.7-.26S433.27,166,433.27,166.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,153.26c0,.15-86.27.26-192.67.26s-192.7-.11-192.7-.26,86.26-.26,192.7-.26S433.27,153.12,433.27,153.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,179.63c0,.15-86.27.26-192.67.26s-192.7-.11-192.7-.26,86.26-.26,192.7-.26S433.27,179.49,433.27,179.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,193.16c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.26,192.7-.26S433.27,193,433.27,193.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,206.69c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.26,192.7-.26S433.27,206.54,433.27,206.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,220.21c0,.15-86.27.26-192.67.26s-192.7-.11-192.7-.26,86.26-.26,192.7-.26S433.27,220.07,433.27,220.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,233.74c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.26,192.7-.26S433.27,233.6,433.27,233.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,247.27c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.26,192.7-.26S433.27,247.12,433.27,247.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,260.79c0,.15-86.27.27-192.67.27s-192.7-.12-192.7-.27,86.26-.26,192.7-.26S433.27,260.65,433.27,260.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,274.32c0,.15-86.27.26-192.67.26s-192.7-.11-192.7-.26,86.26-.26,192.7-.26S433.27,274.18,433.27,274.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,287.85c0,.14-86.27.26-192.67.26S47.9,288,47.9,287.85s86.26-.26,192.7-.26S433.27,287.71,433.27,287.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,301.38c0,.14-86.27.26-192.67.26s-192.7-.12-192.7-.26,86.26-.26,192.7-.26S433.27,301.23,433.27,301.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.97,
    y: 153.26,
    width: 373.43,
    height: 26.37,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,164.61c0,.14-43.95.26-98.14.26s-98.14-.12-98.14-.26,43.93-.27,98.14-.27S356,164.46,356,164.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.55,172.12c0,.14-54.95.26-122.73.26s-122.73-.12-122.73-.26,54.94-.26,122.73-.26S374.55,172,374.55,172.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.33,
    y: 193.16,
    width: 116.06,
    height: 13.53,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.33,
    y: 205.19,
    width: 116.06,
    height: 57.09,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.43,212.85c0,.15-9.58.26-21.39.26s-21.39-.11-21.39-.26,9.58-.26,21.39-.26S166.43,212.71,166.43,212.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.34,227.7c0,.14-5.75.26-12.84.26s-12.85-.12-12.85-.26,5.75-.26,12.85-.26S149.34,227.56,149.34,227.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.56,238.52c0,.14-10.5.26-23.45.26s-23.46-.12-23.46-.26,10.5-.26,23.46-.26S170.56,238.37,170.56,238.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.34,216.89c0,.14-5.75.26-12.84.26s-12.85-.12-12.85-.26,5.75-.27,12.85-.27S149.34,216.74,149.34,216.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.08,212.85a44,44,0,0,1-6.82.26,44.12,44.12,0,0,1-6.83-.26,45.67,45.67,0,0,1,6.83-.26A45.59,45.59,0,0,1,229.08,212.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.08,225a45.59,45.59,0,0,1-6.82.26,45.67,45.67,0,0,1-6.83-.26,44.12,44.12,0,0,1,6.83-.26A44,44,0,0,1,229.08,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.08,238.52a45.59,45.59,0,0,1-6.82.26,45.67,45.67,0,0,1-6.83-.26,44.12,44.12,0,0,1,6.83-.26A44,44,0,0,1,229.08,238.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.33,255.05c0,.14-4.83.26-10.79.26s-10.79-.12-10.79-.26,4.83-.26,10.79-.26S228.33,254.9,228.33,255.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.05,261.29c-.14,0-.26-12.34-.26-27.55s.12-27.55.26-27.55.26,12.33.26,27.55S176.2,261.29,176.05,261.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.42,246.07c0,.14-12.84.26-28.66.26s-28.66-.12-28.66-.26,12.83-.26,28.66-.26S232.42,245.92,232.42,246.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.33,
    y: 287.35,
    width: 116.06,
    height: 14.03,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.14,
    y: 274.32,
    width: 116.25,
    height: 13.53,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54,295.05c0,.15-10.95.26-24.45.26s-24.46-.11-24.46-.26,11-.26,24.46-.26S171.54,294.91,171.54,295.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.33,294.36c0,.14-4.83.26-10.79.26s-10.79-.12-10.79-.26,4.83-.26,10.79-.26S228.33,294.22,228.33,294.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.9,
    y: 240.02,
    width: 10.04,
    height: 34.06,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.9,
    y: 246.2,
    width: 10.04,
    height: 27.88,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.56,
    y: 253.99,
    width: 10.04,
    height: 20.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.23,
    y: 219.13,
    width: 10.04,
    height: 54.95,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.57,
    y: 219.13,
    width: 10.04,
    height: 54.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.23,
    y: 206.44,
    width: 10.04,
    height: 67.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.88,
    y: 121.21,
    width: 8.91,
    height: 8.91,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,134h-9.9V124.1H73Zm-8.9-1H72V125.1h-7.9Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.02,
    y: 123.57,
    width: 8.32,
    height: 8.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.55,
    y: 123.57,
    width: 8.32,
    height: 8.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.07,
    y: 123.57,
    width: 8.32,
    height: 8.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.6,
    y: 123.57,
    width: 8.32,
    height: 8.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.12,
    y: 123.57,
    width: 8.32,
    height: 8.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.82,
    y: 123.49,
    width: 87.94,
    height: 8.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.83,
    y: 123.49,
    width: 87.94,
    height: 8.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.58,
    y: 123.49,
    width: 75.82,
    height: 8.49,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.58,307.24c0-1.58-.08-80.78-.2-209.89l.2.19-387.09.07h0l.26-.26c0,74.16,0,145.16,0,209.89l-.25-.24,387.12.24-387.12.25h-.24v-.25c0-64.73,0-135.73,0-209.89v-.27h.29l387.09.07h.19v.2C435.65,226.46,435.58,305.66,435.58,307.24Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.08,329.6l27,28.81,40.38-12,7.11,15.74S279.71,379.61,275.61,378s-28.76-22.51-28.76-22.51Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.4,348a17.54,17.54,0,0,1-1.91,2.07c-1.2,1.25-2.83,3-4.54,5-2.8,3.3-4.89,6.3-5.61,7.21l-.41.52.28-.59c.13-.28.21-.41.23-.4s0,.16-.09.45l-.13-.07a51.62,51.62,0,0,1,5.33-7.46,61.26,61.26,0,0,1,4.68-4.95A13.27,13.27,0,0,1,268.4,348Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.23,344.62a24.06,24.06,0,0,1-2.19,2.15c-1.36,1.3-3.19,3.15-5.07,5.34s-3.43,4.27-4.51,5.82a22,22,0,0,1-1.79,2.48,14.07,14.07,0,0,1,1.48-2.69,53.54,53.54,0,0,1,4.43-6,52.36,52.36,0,0,1,5.22-5.28A14.17,14.17,0,0,1,266.23,344.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.63,431.4l-.67-3.13-17.45,3.45,1.16,6.82,1.1-.11c4.88-.5,24.77-2.88,27.85-4.37C339.05,432.39,323.63,431.4,323.63,431.4Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313,437.39a6.24,6.24,0,0,0-2.73-3.51,5.18,5.18,0,0,0-4.48-.5l.86,4.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.2,432.15s5.46.67,4.95,1.64-20.53,4.12-29.48,4.75l0-.4L330,434.65S330.19,432.35,331.2,432.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.36,438.17h.31l.87-.09,3.21-.36c2.7-.33,6.44-.84,10.54-1.48s7.82-1.31,10.5-1.83l3.16-.64.86-.19a1.1,1.1,0,0,0,.3-.08l-.31,0-.86.15-3.18.57c-2.68.48-6.39,1.12-10.5,1.77s-7.83,1.17-10.53,1.54l-3.2.43-.87.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,434.92a8,8,0,0,1,.35-1.61,6.81,6.81,0,0,1,.9-1.39,2.88,2.88,0,0,0-1.25,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.46,433.12c.06,0,.26-.32.45-.76a2,2,0,0,0,.25-.85c-.06,0-.26.32-.45.76A2,2,0,0,0,324.46,433.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.92,432.59c.05,0,.3-.19.56-.51s.43-.61.38-.65-.29.19-.55.51S322.88,432.55,322.92,432.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.77,431.08a4.09,4.09,0,0,0,1.83-.27,4.09,4.09,0,0,0-1.83.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.27,430a1.81,1.81,0,0,0,1.07.13,1.79,1.79,0,0,0,1-.3,111.34,111.34,0,0,1-2.1.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.82,431.49a3.1,3.1,0,0,0,1.12-.18,7.11,7.11,0,0,0,1.16-.46,2.75,2.75,0,0,0,.64-.39.57.57,0,0,0,.22-.39.44.44,0,0,0-.24-.42,2.09,2.09,0,0,0-2.46,1,2.2,2.2,0,0,0-.25.81.76.76,0,0,0,0,.31,3.34,3.34,0,0,1,.36-1,2.09,2.09,0,0,1,.87-.78,1.76,1.76,0,0,1,1.35-.12c.2.11.17.33,0,.48a3.64,3.64,0,0,1-.59.37,8.17,8.17,0,0,1-1.12.48C325.24,431.39,324.81,431.46,324.82,431.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.12,431.5a1.22,1.22,0,0,0,0-.8,1.7,1.7,0,0,0-.44-.77,1.11,1.11,0,0,0-1-.43.45.45,0,0,0-.27.57,1.31,1.31,0,0,0,.27.48,3.41,3.41,0,0,0,.64.59,1.75,1.75,0,0,0,.72.36s-.26-.17-.62-.48a3.34,3.34,0,0,1-.58-.6c-.2-.21-.37-.62-.09-.72s.61.17.81.36a1.9,1.9,0,0,1,.44.69A4.18,4.18,0,0,1,325.12,431.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,433.32s.49-.13,1.3-.16a5.66,5.66,0,0,1,3,.72,5.72,5.72,0,0,1,2.16,2.22c.39.7.49,1.21.53,1.19a1,1,0,0,0-.06-.35,4.73,4.73,0,0,0-.34-.92,5.37,5.37,0,0,0-5.31-3,4.85,4.85,0,0,0-1,.18A.85.85,0,0,0,306,433.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.94,435.33a9.54,9.54,0,0,0,2.6-.15,10,10,0,0,0,2.53-.61c0-.06-1.15.19-2.56.4S314.94,435.27,314.94,435.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.5,435.87c0,.05.13.23.29.47s.26.47.32.46.05-.3-.14-.58S311.53,435.82,311.5,435.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,434.46c0,.05.11.22.32.37s.41.24.44.2-.1-.22-.31-.37S310,434.42,310,434.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,434c0,.06.26,0,.53.07s.48.16.52.11-.15-.27-.48-.32S308,434,308,434Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.61,433.88c0,.06.1.13.26.17s.29,0,.3-.05-.1-.13-.26-.16S306.62,433.82,306.61,433.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.16,410.48l60-56.59A19.72,19.72,0,0,1,295.28,348h0l1.19,0a20.69,20.69,0,0,1,19.08,17.37L328,427.7l-25,7-9-50.46-29.63,26.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.19,416.4c-.26.72-1.92,21.48,24,21.48h69.34c8.77,0,15.89-6.68,15.89-14.92h0c0-8.25-7.12-14.93-15.89-14.93H231a16.67,16.67,0,0,0-6.69,1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.69,408c0,.15-14.32.28-32,.28s-32-.13-32-.28,14.32-.28,32-.28S301.69,407.88,301.69,408Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.17,371.05c.16,0,.17,3,.71,6.64s1.39,6.51,1.23,6.57a28,28,0,0,1-1.94-13.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.11,370.62A42.2,42.2,0,0,1,294,384.18c-.16,0,.26-3,.58-6.78S295,370.62,295.11,370.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.06,437.29a19.28,19.28,0,0,0,5.06-3,15.57,15.57,0,0,0,3.86-5,15.05,15.05,0,0,0-1.07-14.78,15.49,15.49,0,0,0-4.54-4.37,19.21,19.21,0,0,0-5.43-2.2,1.41,1.41,0,0,1,.41,0,8.2,8.2,0,0,1,1.17.21,14.54,14.54,0,0,1,4,1.65,15.3,15.3,0,0,1,4.75,4.41,15.26,15.26,0,0,1,1.1,15.26,15.35,15.35,0,0,1-4.05,5.05,14.85,14.85,0,0,1-3.77,2.22,10.08,10.08,0,0,1-1.12.37A1.88,1.88,0,0,1,300.06,437.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.55,276.1l-.56,3-8.71,44.95c-1,5.22,2.67,10.25,8.27,11.29h0c5.65,1,11.12-2.36,12.23-7.62,1.17-5.51,2.49-11.3,2.49-11.3s7.36.3,10.76-8.67c1.69-4.46,3-12.08,3.92-18.34A10,10,0,0,0,262,278Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.54,294.63a1.21,1.21,0,0,1-1.39,1,1.17,1.17,0,0,1-1-1.33,1.22,1.22,0,0,1,1.4-1A1.16,1.16,0,0,1,268.54,294.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,293c-.18.13-.94-.73-2.22-1s-2.35.19-2.46,0,.15-.33.63-.55a3.4,3.4,0,0,1,2-.19,3.19,3.19,0,0,1,1.73,1C268.5,292.65,268.58,293,268.49,293Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.75,291.72a1.22,1.22,0,0,1-1.4,1,1.15,1.15,0,0,1-1-1.32,1.21,1.21,0,0,1,1.39-1A1.18,1.18,0,0,1,255.75,291.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.86,290.64c-.18.12-1-.73-2.23-1s-2.35.18-2.45,0,.15-.34.62-.55a3.36,3.36,0,0,1,2-.19,3.18,3.18,0,0,1,1.73,1C255.87,290.28,255.94,290.59,255.86,290.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.53,301.1a8.63,8.63,0,0,1,2.16.06c.33,0,.66,0,.76-.18a1.77,1.77,0,0,0,0-1c-.14-.85-.29-1.75-.45-2.69a43.85,43.85,0,0,1-.82-7,43.49,43.49,0,0,1,1.38,6.88c.14.94.28,1.84.41,2.7a2,2,0,0,1-.1,1.32.85.85,0,0,1-.64.36,2,2,0,0,1-.57,0A9,9,0,0,1,258.53,301.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.27,316.43a24.12,24.12,0,0,1-11.74-5.89s1.7,7,11.16,8.06Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.58,301.2c.21,0-.07,1.42.91,2.66s2.5,1.38,2.47,1.58-.39.2-1,.09a3.54,3.54,0,0,1-2.07-1.24,3.1,3.1,0,0,1-.68-2.21C254.26,301.49,254.49,301.17,254.58,301.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.23,285.69c-.2.32-1.44-.11-3-.24s-2.84,0-3-.33c-.05-.16.23-.45.79-.68a4.83,4.83,0,0,1,2.31-.31,4.91,4.91,0,0,1,2.22.74C257.1,285.21,257.32,285.54,257.23,285.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.79,289.21c-.29.25-1.1-.24-2.16-.47s-2-.22-2.14-.56c-.06-.17.14-.43.59-.62a3,3,0,0,1,1.86-.11,3,3,0,0,1,1.61.94C268.86,288.77,268.92,289.09,268.79,289.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.74,278.8a3.6,3.6,0,0,0-.26-2.25,2.54,2.54,0,0,0-1-1.55,2.76,2.76,0,0,0-2,.11c-2.27.66-5,.55-6.61-1.22-1.23-1.38-1.47-3.5-2.9-4.67s-3.88-.94-5.81-.32-4,1.45-5.93.87a14,14,0,0,1-3.68-2.33,10.17,10.17,0,0,0-7.59-1.7,8.29,8.29,0,0,0-6,4.76,7,7,0,0,0,1.32,7.42c.09.12.18.23.28.34-.92,4.82-2,12.5.16,13.08,3.19.86,4.33-7.32,4.33-7.32,4.31-.53,5.28-4.75,6.49-5.4s5.85,1.21,9.63,4c4.69,3.46,12.85,4,15.7,4.07a3.76,3.76,0,0,0,.75,0h.27l0,0a2.9,2.9,0,0,0,.55-.17,4.17,4.17,0,0,0,1.82-2.42,5.45,5.45,0,0,0,.53-2.7,2.27,2.27,0,0,0-1.09-1.65A1.45,1.45,0,0,0,280.74,278.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.18,280.71a1,1,0,0,1,.36-.41,1.73,1.73,0,0,1,1.54-.26,1.76,1.76,0,0,1,1.09,2.13,1.73,1.73,0,0,1-1.13,1.15,2.78,2.78,0,0,1-1.8,0c-1.28-.42-2-1.76-2.54-3a14.38,14.38,0,0,0-.89-2,4,4,0,0,0-1.48-1.58,2.85,2.85,0,0,0-2.19-.14c-.77.21-1.54.59-2.39.85a5.43,5.43,0,0,1-2.72.15,7.87,7.87,0,0,1-2.58-1.06,20.69,20.69,0,0,1-4.06-3.56,15.61,15.61,0,0,0-3.78-3.08,6.28,6.28,0,0,0-4.23-.58,6.24,6.24,0,0,0-4.95,6.93,10.38,10.38,0,0,0,.49,2,2.11,2.11,0,0,1-.27-.48,5.84,5.84,0,0,1-.42-1.5,6.59,6.59,0,0,1,1.6-5.39,6.73,6.73,0,0,1,8-1.4,15.62,15.62,0,0,1,3.94,3.14,20.68,20.68,0,0,0,4,3.48,7.54,7.54,0,0,0,2.41,1,5,5,0,0,0,2.47-.13c.81-.24,1.58-.62,2.41-.84a3.32,3.32,0,0,1,2.55.2c1.52.9,2,2.54,2.54,3.8s1.18,2.49,2.27,2.86a2.47,2.47,0,0,0,1.56.06,1.43,1.43,0,0,0,1-.92,1.54,1.54,0,0,0-.88-1.86,1.7,1.7,0,0,0-1.42.15C275.3,280.56,275.2,280.73,275.18,280.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.85,282.51a1.14,1.14,0,0,1-.13.38,3.28,3.28,0,0,1-.67.95,3.55,3.55,0,0,1-1.61.92,3.67,3.67,0,0,1-2.45-.22,5.74,5.74,0,0,1-2.13-2.06,4.62,4.62,0,0,0-1.06-1.1,1.88,1.88,0,0,0-1.47-.28,10.48,10.48,0,0,0-1.67.55,5.62,5.62,0,0,1-1.92.33,8.65,8.65,0,0,1-3.91-1c-2.47-1.29-4.31-3.17-6.29-4.35a7.91,7.91,0,0,0-5.76-1.37,4.72,4.72,0,0,0-3.12,2.42,5.56,5.56,0,0,0-.38,1.46,1.2,1.2,0,0,1,0-.41,3.16,3.16,0,0,1,.24-1.14,4.79,4.79,0,0,1,3.21-2.68,8.11,8.11,0,0,1,6.1,1.31c2.06,1.21,3.91,3.07,6.27,4.29a8.38,8.38,0,0,0,3.67,1,5.22,5.22,0,0,0,1.77-.29,11.93,11.93,0,0,1,1.75-.56,2.36,2.36,0,0,1,1.8.38,5.11,5.11,0,0,1,1.16,1.22,5.35,5.35,0,0,0,1.94,2,3.34,3.34,0,0,0,2.22.28,3.5,3.5,0,0,0,1.54-.79A5.91,5.91,0,0,0,278.85,282.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.54,288.05c-.12-.09-5-2.95-6.17,2.45s4.49,5.47,4.53,5.32S241.54,288.05,241.54,288.05Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7,293.41s-.11,0-.28.09a1,1,0,0,1-.71-.14,2.38,2.38,0,0,1-.62-2.32,3.09,3.09,0,0,1,.56-1.29,1.11,1.11,0,0,1,.86-.57.49.49,0,0,1,.5.38c0,.17,0,.27,0,.28s.13-.06.14-.3a.58.58,0,0,0-.14-.38.73.73,0,0,0-.49-.25,1.35,1.35,0,0,0-1.16.62,3.31,3.31,0,0,0-.66,1.43,2.52,2.52,0,0,0,.86,2.64,1.06,1.06,0,0,0,.9,0C238.66,293.54,238.72,293.43,238.7,293.41Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.86,346.65c1.55.22,11.48,1.72,12.42,2.46s.92,1.78-.2,2-7.39-.2-7.39-.2,8.09.19,8.34,1c.39,1.28-2.49,2-7.9,1.14,0,0,8.25-.88,8.16,1.15,0,1-7.42,1.09-7.42,1.09-.17.57,7.43-1,7.65.22.1.58-.94,1.17-4.8,1.71-2.33.33-6.18.81-10,1.32v.05l-4.18.59-4.9-11.05c.38-.37,2.69-1.82,4.26-2.91a4.92,4.92,0,0,1,3.35-.85h0a3.05,3.05,0,0,1,2.6,2.21Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.58,351.37a108,108,0,0,1-7.72-.76,11,11,0,0,1,3.91-.07A10.73,10.73,0,0,1,341.58,351.37Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.87,353.17a15.78,15.78,0,0,1-3.44,0,16.16,16.16,0,0,1-3.44-.23,9.11,9.11,0,0,1,3.46-.29A9,9,0,0,1,341.87,353.17Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.16,355a16.44,16.44,0,0,1-3.43.39,16,16,0,0,1-3.44.19,8.9,8.9,0,0,1,3.4-.71A9.1,9.1,0,0,1,342.16,355Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.1,376.52l-28.47-4.44a2.52,2.52,0,0,1-2.11-2.89l6-38.36a2.54,2.54,0,0,1,2.9-2.12l19.91,3.1,9.38,12.5L361,374.4A2.54,2.54,0,0,1,358.1,376.52Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.31,331.72l-1.19,7.63a3.46,3.46,0,0,0,2.88,3.94l7.68,1Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356.31,331.72l-1.19,7.63a3.46,3.46,0,0,0,2.88,3.94l7.68,1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M355,368.27a1.69,1.69,0,0,1,0-.37c0-.27.08-.61.14-1,.13-.94.31-2.22.53-3.83.49-3.31,1.17-7.94,2-13.5l.19.26-19.43-3,.29-.21h0v.14l0,.16,0,.32-.1.64c-.07.42-.14.84-.2,1.26l-.39,2.5c-.26,1.64-.51,3.25-.76,4.82-.5,3.13-1,6.09-1.4,8.82l-.19-.26,14,2.3,4,.68,1.06.19a2.24,2.24,0,0,1,.38.08l-.34,0-1-.14-3.93-.55-14.17-2.09-.22,0,0-.23c.42-2.73.87-5.69,1.35-8.83.25-1.57.5-3.18.75-4.82l.39-2.5c.06-.42.13-.84.19-1.26l.1-.64.05-.32,0-.16v-.14h0l.3-.22L358,349.37l.23,0,0,.22c-.92,5.6-1.68,10.27-2.23,13.61-.27,1.58-.49,2.84-.65,3.75-.07.4-.13.72-.17,1A1.29,1.29,0,0,1,355,368.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.08,367a85.23,85.23,0,0,1,1.2-9.38,86,86,0,0,1,1.71-9.3,85.23,85.23,0,0,1-1.2,9.38A85.37,85.37,0,0,1,345.08,367Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.65,363.68a94,94,0,0,1-9.79-1.26,96.33,96.33,0,0,1-9.71-1.77,90.2,90.2,0,0,1,9.79,1.26A92.44,92.44,0,0,1,355.65,363.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.61,359a90.51,90.51,0,0,1-9.78-1.26,95,95,0,0,1-9.71-1.77,90.84,90.84,0,0,1,9.79,1.26A95.09,95.09,0,0,1,356.61,359Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.21,354.17a94.06,94.06,0,0,1-9.72-1.25,88.37,88.37,0,0,1-9.63-1.77,93.71,93.71,0,0,1,9.71,1.25A88.28,88.28,0,0,1,357.21,354.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.03 407.57 249.03 404.01 299.72 405.05 328.91 358.41 331.59 360.35 301.69 408.03 249.03 407.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.1,392l2.55,3.79v7.78a1.69,1.69,0,0,1-1.85-.75,32,32,0,0,1-1.23-4.66l-1.23,3.19a2.77,2.77,0,0,1-3.24,1.68l-9.4-2.36,3.84-11Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,344.41l8.64,2.75a1.42,1.42,0,0,1-1.54,1.5c-1.59-.06-5.83-.46-5.83-.46s0,3-2.5,3.63c0,0-3.14-5.44-3-5.59S327.63,344.41,327.63,344.41Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.27,355.83s-.13-.32-.41-.81a3.61,3.61,0,0,0-1.65-1.54l-.47-.22.49-.2A4.46,4.46,0,0,0,328.5,351a4.53,4.53,0,0,0,.52-2.6l0-.29.29,0a20.15,20.15,0,0,1,3.79.48,20.27,20.27,0,0,1-3.83,0l.25-.27a4.71,4.71,0,0,1-.52,2.9,4.77,4.77,0,0,1-2.57,2.28l0-.42a3.62,3.62,0,0,1,1.69,1.83C328.33,355.47,328.31,355.82,328.27,355.83Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.19,316.8s-11.33,6.48-15.53,12.8S205,343.41,199.79,363.73c-4.51,17.74-6.19,41.8-1.31,48.44a29.74,29.74,0,0,0,5.87,6.35l8.76-3.59c10.43-3.73,19.92-6.14,28.1-13.6l16.61-15.16L249,379.23s6.69-36.14,4.91-48.76C252.39,319.43,232.19,316.8,232.19,316.8Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.85,334.27l-9.28,43.35a15.52,15.52,0,0,0,9.87,17.83l40.31,7.73,5-15h0L241.06,378l9.6-41.88Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.23,385.86l.06.26q.06.27.15.75l.11.55.24.65.27.75c.14.25.29.52.44.81a10.71,10.71,0,0,0,3.26,3.44,18.27,18.27,0,0,0,5.92,2.58l39.87,7.3-.27.15c1.67-4.76,3.42-9.79,5.25-15l.17.33L241,378.22l-.25-.08.07-.26c.56-2.23,1.17-4.62,1.79-7,1.9-7.59,3.68-15,5.23-22.23.76-3.61,1.48-7.16,2-10.67.14-.87.14-1.74.22-2.6a11.82,11.82,0,0,0-.29-2.53,10.64,10.64,0,0,0-2.23-4.45,10.91,10.91,0,0,0-8.55-3.82,11.16,11.16,0,0,0-7.93,4,20.85,20.85,0,0,0-4.09,7.54,65.4,65.4,0,0,0-1.85,7.8c-2,10.05-3.59,18.19-4.71,23.84l-1.3,6.47c-.15.73-.27,1.29-.36,1.69s-.13.57-.13.57a5,5,0,0,1,.08-.58c.07-.41.17-1,.3-1.7.28-1.5.68-3.69,1.2-6.49,1.07-5.66,2.62-13.81,4.53-23.87a65.06,65.06,0,0,1,1.83-7.86,21.33,21.33,0,0,1,4.15-7.71,11.63,11.63,0,0,1,8.27-4.2,11.39,11.39,0,0,1,8.95,4,11.13,11.13,0,0,1,2.35,4.66,11.77,11.77,0,0,1,.3,2.65c-.07.89-.07,1.8-.22,2.68-.49,3.53-1.21,7.09-2,10.7C246.81,356,245,363.39,243.13,371c-.62,2.41-1.23,4.8-1.8,7l-.18-.33,32.7,10.22.25.08-.08.25-5.28,15-.07.19-.2,0c-16.5-3.09-30.24-5.61-39.86-7.5a18.42,18.42,0,0,1-6-2.67,10.71,10.71,0,0,1-3.26-3.55c-.16-.29-.3-.57-.44-.83l-.26-.77-.22-.65q0-.31-.09-.57l-.12-.76A1,1,0,0,1,218.23,385.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.44,383.63c-.06,0-.12-.51.09-1.29a5.84,5.84,0,0,1,1.62-2.69,5.93,5.93,0,0,1,2.75-1.52c.8-.17,1.3-.09,1.3,0s-.48.16-1.19.41a7,7,0,0,0-4.11,3.95C235.61,383.16,235.53,383.64,235.44,383.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.9,333.69a250,250,0,0,0-9.71,46.3,37.53,37.53,0,0,0-.21,10.89c.62,3.6,2.39,7.14,5.45,9.12a13.54,13.54,0,0,0,9.85,1.51c3.35-.64,8.76-1.38,11.83-2.83l-18-3.72s-11.63-.72-6.63-23S226.9,333.69,226.9,333.69Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M249,379.23a9.83,9.83,0,0,1,.19-1.72c.17-1.19.39-2.77.66-4.68.58-4,1.37-9.45,2.23-15.44s1.6-11.49,2.1-15.45l.59-4.69a9.62,9.62,0,0,1,.26-1.71,12.49,12.49,0,0,1-.06,1.73c-.08,1.12-.22,2.73-.43,4.71-.41,4-1.09,9.45-1.95,15.49s-1.7,11.48-2.37,15.41c-.34,2-.62,3.56-.83,4.66A10.35,10.35,0,0,1,249,379.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43,347.69c0,.08-1.29-.41-3.35-1.05a52.9,52.9,0,0,0-16.63-2.43c-2.16,0-3.5.14-3.51.05a3.59,3.59,0,0,1,.93-.18c.6-.09,1.48-.18,2.57-.24a43.43,43.43,0,0,1,16.76,2.45c1,.37,1.84.7,2.39,1A3.6,3.6,0,0,1,248.43,347.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.35,352.15c0,.08-1.3-.42-3.4-1a47.34,47.34,0,0,0-16.9-1.83c-2.18.16-3.53.37-3.54.28a3.68,3.68,0,0,1,.93-.25c.6-.13,1.48-.27,2.58-.39a39.57,39.57,0,0,1,8.62,0,40.73,40.73,0,0,1,8.42,1.84c1.05.36,1.88.69,2.44.94S247.37,352.11,247.35,352.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.63,320.21a3.14,3.14,0,0,0-2-2.94,7.47,7.47,0,0,0-3.33,0,17.66,17.66,0,0,1-11.34-2.74c-3-2-5.45-4.87-8.78-6.23a5.93,5.93,0,0,0-2.71-.51,3.06,3.06,0,0,0-2.35,1.32c-.81,1.27-.27,3,.66,4.19-1.79.91-2.71,3.26-1.56,4.91a31.48,31.48,0,0,1,20.64,12,9.78,9.78,0,0,0,3,3.07c2.37,1.22,5.51-.23,6.64-2.64a7.89,7.89,0,0,0-1-7.56A3.14,3.14,0,0,0,261.63,320.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.24,322.84a3.15,3.15,0,0,1-1,.52,11.21,11.21,0,0,1-2.89.76,12.1,12.1,0,0,1-4.44-.26,14.5,14.5,0,0,1-4.89-2.39c-1.57-1.13-2.93-2.35-4.2-3.39a27.09,27.09,0,0,0-3.54-2.54,18.16,18.16,0,0,0-3.7-1.54,3.45,3.45,0,0,1,1.09.14,11.11,11.11,0,0,1,2.79,1.08,24.68,24.68,0,0,1,3.66,2.48c1.3,1,2.66,2.24,4.2,3.34a14.43,14.43,0,0,0,4.71,2.35,12.11,12.11,0,0,0,4.28.36A18.39,18.39,0,0,0,259.24,322.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.5,333.83a5.1,5.1,0,0,0,.7-.27,3.55,3.55,0,0,0,1.44-1.42,5.12,5.12,0,0,0,.61-2.93,15.33,15.33,0,0,0-.71-3.66,2,2,0,0,0-1.52-1.36l-.18,0L256,324a4.56,4.56,0,0,0,1-2.69,4.51,4.51,0,0,0-.52-2.23,5.47,5.47,0,0,0-1.33-1.61,2.57,2.57,0,0,1,.46.33,4.66,4.66,0,0,1,1,1.22,4.55,4.55,0,0,1,.59,2.29,4.76,4.76,0,0,1-1,2.82L256,324a2.16,2.16,0,0,1,1.69,1.49,14.66,14.66,0,0,1,.72,3.74,5.24,5.24,0,0,1-.68,3,3.56,3.56,0,0,1-1.53,1.41A2.07,2.07,0,0,1,255.5,333.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.47,316.61a4.93,4.93,0,0,1,1.13,1.65,6.69,6.69,0,0,1,.28,4.78l-.16.43v-.09a5.5,5.5,0,0,1,.35,4.46,4.12,4.12,0,0,1-.95,1.6,8.31,8.31,0,0,0,.81-1.64,5.5,5.5,0,0,0-.39-4.31l0-.05,0-.05.15-.41a6.8,6.8,0,0,0-.21-4.66A9.26,9.26,0,0,0,249.47,316.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.27,314.51a1.13,1.13,0,0,1,.19.31,4.42,4.42,0,0,1,.33.95,5,5,0,0,1-.4,3.25,4.8,4.8,0,0,1-.64,1l0-.06a3.17,3.17,0,0,1-1.19,2.2,2.44,2.44,0,0,1-.64.38.63.63,0,0,1-.25.08,8.08,8.08,0,0,0,.81-.55,3.25,3.25,0,0,0,1.07-2.12v0l0,0a5.34,5.34,0,0,0,.61-.93,5.14,5.14,0,0,0,.44-3.13A10.89,10.89,0,0,0,245.27,314.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.84,310.61a6.55,6.55,0,0,0-1.05,1.11,4.43,4.43,0,0,0-.68,3.48l0,.2,0,.1-.1,0a3.1,3.1,0,0,0-2.3,2.37,4.49,4.49,0,0,0,0,1.45,1.12,1.12,0,0,1-.12-.38,3,3,0,0,1,0-1.1,3.18,3.18,0,0,1,2.39-2.54l-.07.13-.06-.21a4.47,4.47,0,0,1,.77-3.62,4.07,4.07,0,0,1,.81-.81A1.4,1.4,0,0,1,239.84,310.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.45,318.36a1.21,1.21,0,0,1-.33-.37,3.33,3.33,0,0,1-.49-1.25,3.24,3.24,0,0,1,.31-2,3.35,3.35,0,0,1,1.86-1.61l-.05.16-.16-.23a3.51,3.51,0,0,1-.49-2.52,3.34,3.34,0,0,1,1-1.82,3.17,3.17,0,0,1,1.22-.72,1.75,1.75,0,0,1,.51-.11,4.21,4.21,0,0,0-1.63.93,3.38,3.38,0,0,0-.93,1.76,3.33,3.33,0,0,0,.48,2.36,1.7,1.7,0,0,0,.15.22l.08.12-.13,0a3.18,3.18,0,0,0-1.76,1.5,3,3,0,0,0-.33,1.87A3.71,3.71,0,0,0,231.45,318.36Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.79,393.38a69.27,69.27,0,0,1,7.62-14.48,9.32,9.32,0,0,1,4-3.7c2.87-1.09,6,.67,8.54,2.36l5.94,3.91a1.53,1.53,0,0,1,.79.91c.1.74-.81,1.16-1.55,1.25a10.62,10.62,0,0,1-7.2-1.78c-1.6-1.1-3.16-2.73-5.09-2.53-2.39.25-3.46,3-4.39,5.26A23.63,23.63,0,0,1,106.29,396",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.78,394.36c.46-11.89.93-23.87,3.77-35.41s8.28-22.77,17.22-30.61c-1.18,10-4.82,19.55-8.42,29q-7.29,19-14.57,38",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.71,398.68a132.08,132.08,0,0,0-9-31.47,7.74,7.74,0,0,0-2.74-3.86c-2-1.22-4.64-.42-6.81.55A55.38,55.38,0,0,0,73,373.05a2,2,0,0,0-.76,1.07,1.4,1.4,0,0,0,1.11,1.44,4,4,0,0,0,2-.12l11.88-2.75a6.2,6.2,0,0,1,3.64-.1c1.39.55,2.17,2,2.84,3.35l11.67,23.52",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.79,393.38a69.27,69.27,0,0,1,7.62-14.48,9.32,9.32,0,0,1,4-3.7c2.87-1.09,6,.67,8.54,2.36l5.94,3.91a1.53,1.53,0,0,1,.79.91c.1.74-.81,1.16-1.55,1.25a10.62,10.62,0,0,1-7.2-1.78c-1.6-1.1-3.16-2.73-5.09-2.53-2.39.25-3.46,3-4.39,5.26A23.63,23.63,0,0,1,106.29,396"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.78,394.36c.46-11.89.93-23.87,3.77-35.41s8.28-22.77,17.22-30.61c-1.18,10-4.82,19.55-8.42,29q-7.29,19-14.57,38"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.71,398.68a132.08,132.08,0,0,0-9-31.47,7.74,7.74,0,0,0-2.74-3.86c-2-1.22-4.64-.42-6.81.55A55.38,55.38,0,0,0,73,373.05a2,2,0,0,0-.76,1.07,1.4,1.4,0,0,0,1.11,1.44,4,4,0,0,0,2-.12l11.88-2.75a6.2,6.2,0,0,1,3.64-.1c1.39.55,2.17,2,2.84,3.35l11.67,23.52"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M123.76,309.08a70.79,70.79,0,0,0-16.55,41.85c-1.12,25.3-2.61,43.53-2.61,43.53h2.79s5.58-51,9.3-59.9S126.18,313,123.76,309.08Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.76,309.08a4.35,4.35,0,0,1-.35.81l-1.07,2.28c-.92,2-2.2,4.88-3.62,8.52s-3,8-4.46,13A132.14,132.14,0,0,0,110.37,350c-.5,2.93-.73,5.83-.94,8.64s-.38,5.52-.53,8.1c-.3,5.17-.62,9.83-1.05,13.72s-.93,7-1.37,9.18c-.2,1.08-.41,1.9-.54,2.47a4.29,4.29,0,0,1-.23.84,5.66,5.66,0,0,1,.13-.87c.1-.56.27-1.39.45-2.48.37-2.15.83-5.28,1.2-9.18s.65-8.54.93-13.71c.14-2.58.29-5.3.5-8.11a87.23,87.23,0,0,1,.94-8.69,126.37,126.37,0,0,1,3.94-16.39c1.51-5,3.11-9.35,4.58-13s2.8-6.52,3.78-8.48c.48-1,.89-1.73,1.16-2.24A7.18,7.18,0,0,1,123.76,309.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.13,332.77s-18.84,18-21,35S110,393.78,110,393.78h1.86S116.28,369.6,122,362,135.44,334.81,134.13,332.77Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.91,333.94a3.44,3.44,0,0,1-.28.57l-.88,1.59-3.28,5.81c-2.76,4.9-6.58,11.7-10,19.55a99.71,99.71,0,0,0-6.74,20.87c-.54,2.76-.85,5-1,6.58-.1.78-.14,1.39-.2,1.8a3.67,3.67,0,0,1-.09.63,2.84,2.84,0,0,1,0-.64c0-.41,0-1,.09-1.81a62.91,62.91,0,0,1,.86-6.63,93.63,93.63,0,0,1,6.62-21,194,194,0,0,1,10.2-19.53c1.42-2.43,2.6-4.38,3.43-5.72l1-1.54A2.76,2.76,0,0,1,133.91,333.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.72,335.93s-2.79,35.53,3.72,56.73h2.23S105.16,346.72,97.72,335.93Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.26,342.65a1.61,1.61,0,0,1,.09.5l.15,1.44c.12,1.33.28,3.12.47,5.3.36,4.48.84,10.67,1.33,17.5s.9,13,1.17,17.52c.13,2.19.23,4,.3,5.32,0,.57,0,1,0,1.44a1.83,1.83,0,0,1,0,.51,1.71,1.71,0,0,1-.09-.5l-.15-1.44c-.12-1.33-.27-3.12-.46-5.3-.37-4.48-.84-10.67-1.33-17.51s-.91-13-1.18-17.52c-.12-2.18-.22-4-.3-5.31,0-.58,0-1.06,0-1.45A2.38,2.38,0,0,1,99.26,342.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.29,390.6s6.83,4.91,6.48,7.19S83,412.33,84,422s8.94,16.3,22.43,15.77,22.61-8.94,21.38-17.52S113.19,398,113,397.33c-.44-1.89,6-6.73,6-6.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.85,403.06c0,.14-5,.26-11.11.26s-11.11-.12-11.11-.26,5-.26,11.11-.26S117.85,402.91,117.85,403.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.42,405.39c0,.14-5.86.26-13.09.26s-13.1-.12-13.1-.26,5.87-.26,13.1-.26S119.42,405.25,119.42,405.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.78,408c0,.14-6.92.26-15.47.26s-15.47-.12-15.47-.26,6.93-.26,15.47-.26S121.78,407.83,121.78,408Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.87,411.41c0,.14-8,.26-17.83.26s-17.84-.12-17.84-.26,8-.26,17.84-.26S123.87,411.26,123.87,411.41Z",
    style: {
      fill: "#fafafa"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/no_data_found.606d5e9e7e71a8d1535aa14ca5e22575.svg";
export { ForwardRef as ReactComponent };